import React from 'react';
import styled from 'styled-components';
import { Body7, Container } from '@ui';
import { TransparentFlatButton } from '@ui/buttons';
import { ASK_FOR_COLUMNS_AGAIN_LABEL, droppedColumnsNotice } from './copy';
import { isMockFeedKey } from './mockFeedKey';

// The read asked for enrichment, the server refused the request, and viewFeed re-read without it —
// so these rows arrived rather than an error. Said out loud because the silent version is
// indistinguishable from a feed that simply has no enrichment: no Sector column, a chooser with
// nothing in it, and no hint that anything was ever asked for.
//
// Read off the FEED's known refusal, not off this one response. Once the refusal is cached the page
// stops sending columns, so no later response carries droppedColumns — and the notice paired with
// that cache silently switched itself off on read 2, restoring the exact silence it was written to
// close.

// Bordered like the error panel but in the quiet colour: a degraded read is still a read, and the
// rows below it are real. It is here so the degradation is legible without looking like a failure.
const NoticePanel = styled.div`
  border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  border-radius: 6px;
  padding: 8px 12px;
`;

export const ColumnsRefusedNotice = ({ result, feedId, refusedColumnNames, onAskAgain }) => (
  <Container top={12}>
    <NoticePanel>
      <Body7 isLowContrast>{droppedColumnsNotice(result, refusedColumnNames)}</Body7>
      {/* The escape from the cache, and the only one there is — clearPage keeps the refusal on
          purpose. Offered only for a real feed: a fixture has no server to ask again. The copy says
          what the press DOES, because "clear the refusal cache" describes a variable and "read it
          again asking for the columns" describes what the analyst gets. Secondary rather than
          primary: the read costs ~24 seconds and usually ends where it started, so it should sit
          beside the explanation rather than compete with the table below it. */}
      {feedId && !isMockFeedKey(feedId) && (
        <Container top={8}>
          <TransparentFlatButton onClick={onAskAgain}>{ASK_FOR_COLUMNS_AGAIN_LABEL}</TransparentFlatButton>
        </Container>
      )}
    </NoticePanel>
  </Container>
);
